const moment = require('moment');

export function formatToDateObject(value: number | string | number[] | string[]): Date | undefined | Date[] {
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(v => new Date(v))
    return new Date(value)
}

export function formatDateToLocalFormat(date: any) {
    if (!date) return null;
    if (moment(date).isValid()) return moment(date).format('DD.MM.YYYY')
}

export function formatDateToISO8601(date: any) {
    if (!date) return null;
    if (moment(date).isValid()) return moment(date).format('YYYY-MM-DD')
}

